import SectionHeader from "../Shared/SectionHeader";
import "./AboutResearch.scss";

export default function AboutResearch() {
	return (
		<section className="about-research" id="about-research">
			<div className="content">
				<SectionHeader
					number={2}
					title="Research"
				/>
				<div className="container card-container">
					<div className="row gy-4">
						<CardWrapper>
							<div className="research-card one">
								<div>foundations of spacetime theories</div>
								<div>									
									One of my central areas of interest is the foundations of spacetime theories. In my dissertation, I was especially interested in theories of gravity with torsion. Together with Jim Weatherall, I considered <a href="https://www.cambridge.org/core/journals/philosophy-of-science/article/torsion-in-the-classical-spacetime-context/0AC21F88F934E0654AF565A64C6C8D97">what torsion would look like in the classical (i.e., non-relativistic) spacetime context</a>. We also investigated a relativistic torsional theory, Teleparallel Gravity, and whether it is <a href="https://philosophyofphysics.lse.ac.uk/articles/152/files/682c58dc7eec4.pdf">theoretically equiavalent to General Relativity. </a>
								</div>
							</div>
						</CardWrapper>
						<CardWrapper>
							<div className="research-card two">
								<div>use of simulations in astrophysics</div>
								<div>
									I have written on the use of "physics-informed" machine learning (forthcoming but accessible <a href="https://philsci-archive.pitt.edu/23067/">here</a>). I have also been part of a collaboration in which we investigated the use of code comparisons to increase trust in simulation results. The scientific results of this collaboration are published in <a href="https://academic.oup.com/mnras/article/513/2/2600/6569716?guestAccessKey=1f0834f4-fa41-4360-8e21-3790151c84f4"> Monthly Notices of the Royal Astronomical Society</a> while the philosophical reflection on the methodology is published in <a href="https://link.springer.com/book/10.1007/978-3-031-26618-8">Philosophy of Astrophysics</a>, edited volume. Finally, I have argued that the use of "black-boxes" need not undercut scientific understanding (published in <a href="https://link.springer.com/article/10.1007/s10670-021-00434-5">Erkenntnis</a>).
								</div>
							</div>
						</CardWrapper>
						<CardWrapper>
							<div className="research-card three">
								<div>pedagogy</div>
								<div>
									<a href="https://sites.google.com/view/fcalderon/">Francisco Calderon</a>, <a href="https://philpeople.org/profiles/thomas-colclough">Tom Colclough</a>, and I have investigated feminist- and trauma-informed approaches to teaching logic and philosophy of physics. You can read about our work <a href="https://blog.apaonline.org/2025/05/28/changing-the-way-we-teach-formal-philosophy/">here.</a> I have also coauthored papers about research-informed pedagogy in and for philosophy (in
									<a href="https://www.pdcnet.org/aaptstudies/content/aaptstudies_2019_0005_0169_0199"> AAPT: Studies in Pedagogy</a>),
									ameliorating the
									underrepresentation of
									women in philosophy (in
									<a href="https://ojs.lib.uwo.ca/index.php/fpq/article/view/3107/"> Feminist Philosophy
										Quarterly</a>), as well as
									student-faculty partnerships
									(in <a href="https://www.centerforengagedlearning.org/books/power-of-partnership/section-one/chapter-2/">The Power of Partnership</a>,
									collected volume)
								</div>
							</div>
						</CardWrapper>
					</div>
				</div>
			</div>
		</section>
	);
}

function CardWrapper({
	children
}: {
	children: any
}) {
	return (
		<div className="col-md-10 col-sm-12 mx-auto">
			{children}
		</div>
	);
}